import { render, staticRenderFns } from "./ResolveAction.vue?vue&type=template&id=dfaf2668&scoped=true&"
import script from "./ResolveAction.vue?vue&type=script&lang=js&"
export * from "./ResolveAction.vue?vue&type=script&lang=js&"
import style0 from "./ResolveAction.vue?vue&type=style&index=0&id=dfaf2668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaf2668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfaf2668')) {
      api.createRecord('dfaf2668', component.options)
    } else {
      api.reload('dfaf2668', component.options)
    }
    module.hot.accept("./ResolveAction.vue?vue&type=template&id=dfaf2668&scoped=true&", function () {
      api.rerender('dfaf2668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/buttons/ResolveAction.vue"
export default component.exports